export const Message = {
  required: 'Vui lòng không bỏ trống.',
};
